export const PJ_CONSTANTS = {
  RECALL_LIMIT: 50,
  RECALL_DELAY_MS: 2000,
  MESSAGE_URA:
    'Cliente transferido para URA autenticadora, aguarde o retorno da ligação em até',
  TIME_MODAL_URA: 120,
};
